import * as React from 'react';
import { Trans } from 'react-i18next';
import { cn } from './text-signature';

interface LegalLegendProps {
    i18nKey: string;
    children: React.ReactNode;
    className?: string;
}

/**
 * A reusable component for displaying legal disclaimers or help texts
 * with a standardized style (9px, italic, gray-400, justified).
 */
export const LegalLegend = ({
    i18nKey,
    children,
    className,
}: LegalLegendProps) => (
    <p
        className={cn(
            'text-[9px] leading-tight text-gray-400 mt-2 text-justify italic opacity-80 px-1',
            className
        )}>
        <Trans i18nKey={i18nKey}>{children}</Trans>
    </p>
);
